module.exports = "/_next/static/images/6da25706639ad844c84ac877524eae99-paperwork@mobile480.jpg";